import React, { useEffect, useState } from "react";
import generatePDF from "../services/reportGenerator";
import axios from "axios";


const Parkings = () => {

  const [parkings, setParkings] = useState([]);


  useEffect(() => {
    const getAllParkings = async () => {
      try {
        const response = await axios.get("http://176.107.133.68:8080/api/parkings");
        setParkings(response.data);
      } catch (err) {
        console.log("error");
      }
    };
    getAllParkings();
  }, []);

const reportParkings = parkings;//.filter(ticket => ticket.status === "completed");

  return (
    <div>

      {/*      <button
              className="btn btn-primary"
              onClick={() => generatePDF(reportParkings)}
            >
              Generate PDF
            </button>*/}
   </div>

  );
};

export default Parkings;
